/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  NotificationCountBreakdownResponse,
  NotificationReadRequest,
  NotificationRequest,
  NotificationResponse,
  PageResponseNotificationResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Notifications<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags rest-notification-controller
   * @name MarkNotificationsAsRead
   * @request POST:/notifications/status
   * @secure
   * @response `200` `(NotificationResponse)[]` OK
   */
  markNotificationsAsRead = (
    data: NotificationReadRequest,
    params: RequestParams = {},
  ) =>
    this.request<NotificationResponse[], any>({
      path: `/notifications/status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rest-notification-controller
   * @name MarkAllNotificationsAsRead
   * @request POST:/notifications/status/all
   * @secure
   * @response `200` `PageResponseNotificationResponse` OK
   */
  markAllNotificationsAsRead = (params: RequestParams = {}) =>
    this.request<PageResponseNotificationResponse, any>({
      path: `/notifications/status/all`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rest-notification-controller
   * @name GetUnreadNotificationsCountForUser
   * @request POST:/notifications/getUnreadNotifications/count
   * @secure
   * @response `200` `number` OK
   */
  getUnreadNotificationsCountForUser = (
    data: NotificationRequest,
    params: RequestParams = {},
  ) =>
    this.request<number, any>({
      path: `/notifications/getUnreadNotifications/count`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rest-notification-controller
   * @name GetUnreadNotificationsCountBreakdown
   * @request POST:/notifications/getUnreadNotifications/count/breakdown
   * @secure
   * @response `200` `NotificationCountBreakdownResponse` OK
   */
  getUnreadNotificationsCountBreakdown = (
    data: NotificationRequest,
    params: RequestParams = {},
  ) =>
    this.request<NotificationCountBreakdownResponse, any>({
      path: `/notifications/getUnreadNotifications/count/breakdown`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rest-notification-controller
   * @name GetNotificationsForUser
   * @request POST:/notifications/getNotifications
   * @secure
   * @response `200` `PageResponseNotificationResponse` OK
   */
  getNotificationsForUser = (
    data: NotificationRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseNotificationResponse, any>({
      path: `/notifications/getNotifications`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
